import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import { useMemo } from "react";
import validationSchema from "./validationSchema";

interface Props {
    isSaving: boolean,
    error:  string,
    onSubmit: (_formData: any) => void,
}

const DeviceForm = ({
    isSaving,
    error = '',
    onSubmit,
}: Props) => {
    const validation = useFormik({
        initialValues: {
            name: "",
        },
        validationSchema,
        onSubmit,
    });

    const isButtonDisabled = useMemo(() =>
    isSaving || !validation.values.name.trim()
, [isSaving, validation.values.name]);

    return (
        <Form
            onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}
        >
            <Row>
                <Col xs={12}>
                    <div className="mb-3">
                        <Label className="form-label">Machine Serial Number</Label>
                        <Input
                            name="name"
                            type="text"
                            placeholder="Machine Serial Number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={validation.touched.name && !!(validation.errors.name || error)}
                        />
                        {validation.touched.name && (validation.errors.name || error) ? (
                            <FormFeedback type="invalid">
                                <>{validation.errors.name || error}</>
                            </FormFeedback>
                        ) : null}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="text-end">
                        <button
                            type="submit"
                            className="btn btn-danger"
                            disabled={isButtonDisabled}
                        >
                            SUBMIT
                        </button>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};

export default DeviceForm;
